import { Text } from 'src/design/atoms/Text';
import { BasicActionIcon } from 'src/design/atoms/BasicActionIcon';
import { Menu } from 'src/design/molecules/Menu';
import { IconDotsVertical, IconEdit, IconTrash } from '@tabler/icons-react';
import React from 'react';
import { useDeletePost } from 'src/api/queries/posts/usePostMutations';
import { ConfirmDeletePostModal } from './ConfirmDeletePostModal';

interface PostMenuProps {
  postId: string;
  jobId: number;
  onEditClicked: () => void;
}

export const PostMenu: React.FC<PostMenuProps> = ({
  postId,
  jobId,
  onEditClicked,
}) => {
  const [confirmDeleteOpen, setConfirmDeleteOpen] = React.useState(false);
  const deletePost = useDeletePost(jobId);

  const handleDelete = () => deletePost.mutate(postId);

  return (
    <>
      <ConfirmDeletePostModal
        open={confirmDeleteOpen}
        onCancel={() => setConfirmDeleteOpen(false)}
        onConfirm={handleDelete}
        deleting={deletePost.isPending}
      />
      <Menu position="bottom-end" withinPortal>
        <Menu.Target>
          <BasicActionIcon variant="subtle">
            <IconDotsVertical size={16} />
          </BasicActionIcon>
        </Menu.Target>

        <Menu.Dropdown>
          <Menu.Item
            leftSection={<IconEdit size={16} />}
            onClick={onEditClicked}
          >
            <Text size="sm">Edit Post</Text>
          </Menu.Item>
          <Menu.Item
            leftSection={<IconTrash size={16} />}
            onClick={() => setConfirmDeleteOpen(true)}
            color="red"
          >
            <Text size="sm">Delete Post</Text>
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
    </>
  );
};
